import {
  BarChart3, Globe, Wallet, FileText, DollarSign, Archive, Zap, Sparkles,
  Calculator, MessageCircle, Tags, Building2, Settings, UserCog, CreditCard,
  Receipt, Key, Bot, Database, Trash2, Truck, Package,
  BadgeCheck,
  ListChecks, TrendingDown, PackageCheck, FilePlus,} from 'lucide-react';
import { SITE } from '../../utils/siteConfig';
import { isPrimaryAdmin, isPosOnlyUser } from '../../utils/roleRouting';
import { EQUIPE_MAGASINS_PATH, equipeMagasinsUrl } from '../../utils/navigation/hubNavigation';

/** Entrées drawer Plus — LOT-UI-02 */
export function getPlusMenuSections({ isAdmin, isSuperAdmin, user, t }) {
  // Absent / suspension : aucun accès au menu Plus
  if (isPosOnlyUser(user)) return [];

  const mr = user?.magasin_role || (user?.role === 'admin' ? 'super_admin' : null);
  const isSuper = mr === 'super_admin' || user?.username === 'carlos';
  const isAdminMag = mr === 'admin_magasin';
  const isTech = mr === 'technicien' || user?.role === 'technicien';
  const showAdmin = isAdmin || isSuper || isAdminMag;

  const sections = [];

  if (showAdmin) {
    sections.push({
      key: 'rapports',
      label: 'Rapports',
      items: [
        { path: '/analytics', icon: BarChart3, label: 'Analytics' },
        ...(SITE.isRemobiles ? [{ path: '/site-analytics', icon: Globe, label: 'Analytics site' }] : []),
        { path: '/stats', icon: BarChart3, label: 'Statistiques' },
        { path: '/mes-commissions', icon: Wallet, label: 'Mes commissions' },
        ...(isAdmin ? [{ path: '/admin/commissions', icon: Wallet, label: 'Commissions admin' }] : []),
        ...(isAdmin ? [{ path: '/admin/b2b', icon: Building2, label: 'Gestion B2B' }] : []),
      ],
    });
    sections.push({
      key: 'documents',
      label: 'Documents & compta',
      items: [
        { path: '/devis-factures', icon: FileText, label: t?.('nav.devis') || 'Devis & factures' },
        { path: '/devis-deplacement', icon: FilePlus, label: 'Créer / envoyer un devis' },
        { path: '/avoirs', icon: Receipt, label: 'Avoirs' },
        ...(isAdmin ? [{ path: '/comptabilite', icon: DollarSign, label: 'Comptabilité' }] : []),
        ...(isAdmin ? [{ path: '/caisse-historique', icon: Archive, label: t?.('nav.caisseHistory') || 'Historique caisse' }] : []),
      ],
    });
    sections.push({
      key: 'promos',
      label: 'Promotions',
      items: [
        ...(isAdmin ? [{ path: '/offres-flash', icon: Zap, label: 'Offres flash' }] : []),
        ...(isAdmin ? [{ path: '/admin/promotions', icon: Sparkles, label: 'Promotions' }] : []),
        { path: '/promotions', icon: Sparkles, label: 'Calendrier promos' },
      ],
    });
  }

  sections.push({
    key: 'outils',
    label: 'Outils',
    items: [
      { path: '/activite', icon: Archive, label: t?.('nav.activityHub') || 'Centre Activité' },
      { path: '/activite?tab=ventes', icon: Receipt, label: 'Ventes & tickets' },
      { path: '/historique-ventes', icon: Receipt, label: 'Historique détaillé (legacy)' },
      { path: '/hub', icon: Sparkles, label: 'Hub' },
      ...(!isTech ? [{ path: '/calcul', icon: Calculator, label: t?.('nav.calcul') || 'Calcul marge' }] : []),
      { path: '/chat', icon: MessageCircle, label: 'Support / Chat' },
      ...(!isTech ? [{ path: '/chat/devis-ia', icon: Bot, label: 'Auto-Devis', animated: true }] : []),
      { path: '/commandes', icon: Truck, label: 'Commandes pièces clients' },
      ...(showAdmin ? [{ path: '/etiquettes', icon: Tags, label: t?.('nav.etiquettes') || 'Étiquettes' }] : []),
      ...(showAdmin ? [{ path: '/stock/commandes-pieces', icon: Package, label: 'Appro fournisseur' }] : []),
    ],
  });

  if (showAdmin) {
    const adminItems = [
      { path: '/admin/company-settings', icon: Settings, label: 'Paramètres entreprise' },
    ];
    adminItems.push({
      path: isSuper ? EQUIPE_MAGASINS_PATH : equipeMagasinsUrl('b2b'),
      icon: isSuper ? Building2 : UserCog,
      label: t?.('nav.equipeMagasins') || (isSuper ? 'Équipe & magasins' : t?.('nav.users') || 'Utilisateurs'),
    });
    adminItems.push(
      { path: '/subscription', icon: CreditCard, label: 'Mon abonnement' },
      { path: '/admin/settings/printer', icon: Settings, label: 'Impression' },
    );
    sections.push({
      key: 'admin',
      label: 'Administration',
      items: [
        ...adminItems,
        { path: '/admin/sumup-terminal', icon: CreditCard, label: 'Terminal SumUp (TPE)' },
        { path: '/admin/payment-config', icon: CreditCard, label: 'Config. paiements' },
        { path: '/admin/email-config', icon: Settings, label: 'Config. email' },
        ...(isAdmin ? [{ path: '/admin/cache-fournisseurs', icon: Database, label: 'Données fournisseurs' }] : []),
        ...(isAdmin ? [{ path: '/admin/cadbot-prix', icon: BadgeCheck, label: 'Validation prix CADBOT' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/a-faire', icon: ListChecks, label: 'À faire (direction)' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/pertes', icon: TrendingDown, label: 'Pertes (vendeurs)' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/ventes-hors-stock', icon: PackageCheck, label: 'Ventes hors stock à confirmer' }] : []),
        ...(isAdmin ? [{ path: '/admin/identifiants-fournisseurs', icon: Key, label: 'Identifiants fournisseurs' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/database', icon: Settings, label: 'Base de données' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/cache-purge-ventes', icon: Trash2, label: 'Purge ventes (cache)' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/cles-api', icon: Key, label: 'Clés API (direction)' }] : []),
        ...(isPrimaryAdmin(user) ? [{ path: '/admin/audit', icon: Settings, label: 'Audit & sécurité' }] : []),
      ],
    });
  }

  return sections;
}
